export const DOTENV = process.env.DOTENV;
export const ENV_DIRECTORY = 'environment/';
export const IS_DEVELOPMENT = DOTENV === 'development' || DOTENV === 'development_prod';
export const IS_PRODUCTION = DOTENV === 'production';
export const IS_BUILDING = process.env.IS_BUILDING === 'true';
export const IS_DEPLOYING = process.env.IS_DEPLOYING === '1';
